import React from 'react';
import { getDateTime } from '../../utils/common';

const HalfTimeTable = ({
  matchTimeline, eventType, getTimezone, matchTimelineEvents, tableColor,
}) => {
  const period = matchTimeline.find((event) => event.eventType
    === eventType);

  const time = getDateTime(period.dateTime, getTimezone).split(' ')[1].replace(/:/g, ' : ');
  const eventName = matchTimelineEvents[eventType];
  if (period) {
    return (
      <div className="table-responsive m-t-30">
        <table className="match">
          <thead className={`thead--${tableColor}`}>
            <tr>
              <th>{time}</th>
              <th>&nbsp;</th>
              <th>{eventName}</th>
              <th>&nbsp;</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
        </table>
      </div>
    );
  }
  return null;
};

export default HalfTimeTable;
